export default __webpack_public_path__ + "static/media/Group502@2x.35ef6d52.png";